import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';

import { AuthService } from '../../../common/auth/auth.service';
import { AbstractFetchAdaptor } from '../../../common/fetch/abstract-fetch.adaptor';

interface AuthTokenProps {
  token: string;
}

interface AuthStaticTokenResponse {
  jwt: string;
}

interface AuthRefreshTokenResponse {
  jwt: string;
  refresh_token: string;
  jwt_expire_at: string;
  refresh_token_expire_at: string;
}

export type AuthTokenResponse = AuthStaticTokenResponse | AuthRefreshTokenResponse;

@Injectable()
export class AuthTokenFetchAdaptor extends AbstractFetchAdaptor<AuthTokenProps, AuthTokenResponse> {
  override name = 'auth-token';

  private http = inject(HttpClient);
  private auth = inject(AuthService);
  private navCtrl = inject(NavController);

  override onRequest(props: AuthTokenProps): Observable<AuthTokenResponse> {
    return this.http.post<AuthTokenResponse>('/accounts/auth_tokens', null, {
      params: { login_token: props.token },
    });
  }

  override onSuccess(_props: AuthTokenProps, res: AuthTokenResponse): void {
    if ('refresh_token' in res) {
      const { jwt: accessToken, refresh_token: refreshToken, jwt_expire_at, refresh_token_expire_at } = res;
      this.auth.setToken({
        accessToken,
        refreshToken,
        accessTokenExpiry: new Date(jwt_expire_at),
        refreshTokenExpiry: new Date(refresh_token_expire_at),
      });
    } else {
      this.auth.setToken(res.jwt);
    }
    this.navCtrl.navigateForward(['dashboard']);
  }
}
